import { useEffect } from "react";
import { site } from "../config/site";

/**
 * Setzt Titel/Meta/Canonical/JSON-LD manuell per DOM-API statt über
 * react-helmet-async oder Reacts natives Tag-Hoisting — beides hat sich
 * in der Praxis mit React 19 als Absturzquelle beim Seitenwechsel erwiesen
 * ("destroy is not a function" beim Unmount). Diese Variante ist bewusst
 * simpel und hat eine garantiert korrekte Cleanup-Funktion.
 *
 * Pro Seite einbinden: <Seo title="..." description="..." path="/..." />
 */
export default function Seo({ title, description, path = "" }) {
  const fullTitle = title ? `${title} – ${site.name}` : site.name;
  const url = `${site.url}${path}`;
  const desc = description || site.tagline;

  useEffect(() => {
    const previousTitle = document.title;
    document.title = fullTitle;

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "SportsClub",
      name: site.name,
      url: site.url,
      telephone: site.contact.phone,
      email: site.contact.email,
      address: {
        "@type": "PostalAddress",
        streetAddress: site.contact.address,
        addressCountry: "CH",
      },
      sport: "Fussball",
    };

    const createdElements = [];

    function addMeta(attrs) {
      const el = document.createElement("meta");
      Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
      document.head.appendChild(el);
      createdElements.push(el);
    }

    addMeta({ name: "description", content: desc });
    addMeta({ property: "og:title", content: fullTitle });
    addMeta({ property: "og:description", content: desc });
    addMeta({ property: "og:type", content: "website" });
    addMeta({ property: "og:url", content: url });

    const canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("href", url);
    document.head.appendChild(canonical);
    createdElements.push(canonical);

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    createdElements.push(script);

    return function cleanup() {
      document.title = previousTitle;
      createdElements.forEach((el) => el.remove());
    };
  }, [fullTitle, desc, url]);

  return null;
}
